export default __webpack_public_path__ + "static/media/demoimage.34c73832.jpg";